var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app1"}},[_c('p',[_vm._v("count "+_vm._s(_vm.count))]),_c('p',[_vm._v(_vm._s(_vm.message)+"tes")]),_c('p',[_c('button',{on:{"click":_vm.add}},[_vm._v("+")])])])}
var staticRenderFns = []

export { render, staticRenderFns }